<template>
<div>
    <v-card>
      <v-toolbar dense class="toolbar" height="35px" color="grey lighten-3">            
      </v-toolbar>
       <ag-grid-vue style="width:100%;height:100%"
                 class="ag-theme-balham"
                 domLayout="autoHeight"
                 :columnDefs="columnDefs"
                 :enableFillHandle="true"
                 :defaultColDef="defaultColDef"                 
                 :context="context"
                 @cell-value-changed="gridDataChanged"
                 :rowData="invoices">
                </ag-grid-vue>
    </v-card>
    
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import {AgGridVue} from "ag-grid-vue";
  import { customerService } from './../../services/'        
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'invoices',
    computed: {
        ...mapState('invoice', ['selectedInvoice','newInvoiceData']),
    },
    mixins: [validationMixin],  
    components: {
            AgGridVue,            
        },
    beforeMount() {
        this.context = { componentParent: this };
    },
    mounted() {  
      this.loadInvoices(this.selectedCustomerId)
    },
    props: ['selectedCustomerId'],
      watch: { 
         selectedCustomerId: function(newVal, oldVal) {
           console.log("customer did change")
           console.log(oldVal)
        this.loadInvoices(newVal)
      }
    },
    data: () => ({
      invoices:[],
      invoice: {
        id: null,
        date: null,     
      },
      flightData:[],
      context: null,
      columnDefs:[
          { headerName: 'Invoice No', field:'id' ,minWidth:100},
          { headerName: 'Inv Date' , field: 'createdAt',minWidth:150,
            sort: 'asc',
            comparator: (d1, d2) => new Date(d1).getTime() - new Date(d2).getTime(),
            valueFormatter: params => params.value ? moment(params.value).format('DD-MM-YYYY') : ''},
          { headerName: 'Customer Name' , field: 'User.name', minWidth:150},
          { headerName: 'Cost' , field: 'cost' ,minWidth:150 },
        ],       
        menuItems:["sabre","gds"],
        defaultColDef: {
          flex: 1,
        editable: true
      },
      suppliers: [],
      gdsValues: []
    }),
    created () {
      // let self = this
    },
    methods: {
      ...mapActions('invoice', ['updateFlightData']),        
        loadInvoices(customerId)  {
          let self=this
          self.isLoading=true
          customerService.getInvoices(customerId).then(trasactions=> {              
              self.invoices=trasactions
              self.isLoading=false
          })
        }    
    }
  }
</script>

<style lang="scss">
  .thead-container {
    height: auto !important;
    padding: 0px 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    height: 28px !important;
  }

</style>

<style scoped>
  .v-btn {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
</style>